<template>
  <div>
    <v-img :src="require('@/assets/img-contact-us-inner.jpg')" />
    <v-container class="py-4 mb-8">
      <div
        class="display-4 font-medium line-bottom line-center text-uppercase text-center"
        :class="$store.state.mobile ? 'mb-10' : 'my-6'"
      >
        <template v-if="$store.getters.languageGetter === '1'">
          معلومات الاتصال بالشركة
        </template>
        <template v-else>
          Contact Us
        </template>
      </div>
      <v-row class="mt-10 text-center">
        <v-col
          cols="6"
          lg="3"
        >
          <v-btn
            class="my-3"
            outlined
            style="width:150px;height:150px;border-color:#ccc"
            fab
            color="#111f5e"
          >
            <v-icon
              style="font-size:48px"
            >
              mdi-phone-outline
            </v-icon>
          </v-btn>
          <div class="text-h2 font-medium text-uppercase">
            <template v-if="$store.getters.languageGetter === '1'">
              هاتف
            </template>
            <template v-else>
              Tel
            </template>
          </div>
          <div class="text-h4 grey--text text--darken-2">
            {{ webConfig.tel }}
          </div>
        </v-col>
        <v-col
          cols="6"
          lg="3"
        >
          <v-btn
            class="my-3"
            outlined
            style="width:150px;height:150px;border-color:#ccc"
            fab
            color="#111f5e"
          >
            <v-icon style="font-size:48px">
              mdi-cellphone-iphone
            </v-icon>
          </v-btn>
          <div class="text-h2 font-medium text-uppercase">
            <template v-if="$store.getters.languageGetter === '1'">
              هاتف محمول
            </template>
            <template v-else>
              Mob
            </template>
          </div>
          <div class="text-h4 grey--text text--darken-2">
            {{ webConfig.mobile }}
          </div>
        </v-col>
        <v-col
          cols="6"
          lg="3"
        >
          <v-btn
            class="my-3"
            outlined
            style="width:150px;height:150px;border-color:#ccc"
            fab
            color="#111f5e"
          >
            <v-icon style="font-size:48px">
              mdi-email
            </v-icon>
          </v-btn>
          <div class="text-h2 font-medium text-uppercase">
            <template v-if="$store.getters.languageGetter === '1'">
              البريد الإلكتروني
            </template>
            <template v-else>
              Email
            </template>
          </div>
          <div class="text-h4 grey--text text--darken-2">
            {{ webConfig.email }}
          </div>
        </v-col>
        <v-col
          cols="6"
          lg="3"
        >
          <v-btn
            class="my-3"
            outlined
            style="width:150px;height:150px;border-color:#ccc"
            fab
            color="#111f5e"
          >
            <v-icon style="font-size:48px">
              mdi-map-marker
            </v-icon>
          </v-btn>
          <div class="text-h2 font-medium text-uppercase">
            <template v-if="$store.getters.languageGetter === '1'">
              عنوان الشركة
            </template>
            <template v-else>
              Add
            </template>
          </div>
          <div class="text-h4 grey--text text--darken-2">
            {{ $store.getters.languageGetter === '1' ? webConfig.addressPart : webConfig.addressPartEn }}
          </div>
        </v-col>
      </v-row>
    </v-container>
    <news-letter />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import NewsLetter from '@/layout/NewsLetter.vue';

export default {
  name: 'ContactUs',
  components: {
    NewsLetter,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState(['webConfig']),
  },
};
</script>
